import { useSyncExternalStore } from 'react';
import { useAuthStore } from '@/store/auth-store';
import { sessionScope, sessionRevision, sessionTenantId, requireCurrentSession } from '@/features/auth/session-scope';
import { getLocaleSnapshot } from '@/lib/i18n/runtime';
export function personalOwner(){
 const state=useAuthStore.getState();
 return {scope:sessionScope(state),revision:sessionRevision(),user:state.user?.id??'',tenant:sessionTenantId(state),language:getLocaleSnapshot().locale};
}
export type PersonalOwner=ReturnType<typeof personalOwner>;
export function requirePersonalOwner(owner:PersonalOwner,signal?:AbortSignal){
 requireCurrentSession(owner.revision);signal?.throwIfAborted();
 if(owner.scope!==sessionScope(useAuthStore.getState()))throw new DOMException('Aborted','AbortError');
}
export function personalHeaders(owner:PersonalOwner,write=false){
 requirePersonalOwner(owner);
 const token=useAuthStore.getState().token;
 if(!token||!owner.user||!owner.tenant)throw new DOMException('Aborted','AbortError');
 return {Authorization:token.startsWith('Bearer ')?token:'Bearer '+token,'Accept-Language':write?owner.language:getLocaleSnapshot().locale};
}
export function usePersonalIdentity(){
 const scope=useAuthStore(sessionScope),revision=useSyncExternalStore(cb=>useAuthStore.subscribe(cb),sessionRevision);
 return JSON.stringify([scope,revision]);
}
